import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Angular2SmartTableModule, LocalDataSource } from 'angular2-smart-table';
import { BlockUI, BlockUIModule, NgBlockUI } from 'ng-block-ui';
import { IGetVoucherResponseModel, VouchersService } from '../../services/vouchers/vouchers.service';
import { FormsModule } from '@angular/forms';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@Component({
    selector: 'app-list-voucher',
    templateUrl: './list-voucher.component.html',
  styleUrls: ['./list-voucher.component.css'],
  imports: [FormsModule, AlertModule, BlockUIModule, Angular2SmartTableModule, BsDatepickerModule]
})
export class ListVoucherComponent implements OnInit {
  public failureAlerts: any[] = [];
  includeExpired = false;    

  vouchers: IGetVoucherResponseModel[];
  vouchersSource: LocalDataSource;
  bsRangeValue: Date[];
  currentDate = new Date();
  isDataLoaded = false;

  @BlockUI('vouchers-list') blockUI: NgBlockUI;

  constructor(
    private vouchersService: VouchersService) {
    this.vouchersSource = new LocalDataSource([]);
    let minDate = new Date();
    let maxDate = new Date();
    minDate.setDate(this.currentDate.getDate() - 6);
    maxDate.setDate(this.currentDate.getDate());
    this.bsRangeValue = [minDate, maxDate];

    this.filterVouchers();
  }

  ngOnInit() {
  }

  filterVouchers() {
    if (this.bsRangeValue == undefined) {
      this.showErrorMsg('Select a valid date range');
      return;
    }

    let minDate = new Date(this.bsRangeValue[0].setUTCHours(0, 0, 0, 0));
    let maxDate = new Date(this.bsRangeValue[1].setUTCHours(23, 59, 59, 999));
    if (!this.validateDateRange(minDate, maxDate)) {
      return;
    }

    this.blockUI.start();

    this.vouchersService.getVouchers(minDate, maxDate, this.includeExpired)
      .subscribe((data) => {
        this.vouchers = data.vouchers;
        this.vouchersSource.load(data.vouchers);
        this.blockUI.stop();
        this.isDataLoaded = true;
      },
      (error) => {
        this.showErrorMsg("Sorry, but something went wrong");
        this.blockUI.stop();
      });
  }

  public exportToCsv(): void {

    if (this.isDataLoaded && this.vouchers.length > 0)
    {
      var csvContent = "";
      const columns = Object.keys(this.vouchers[0]);

      csvContent = columns.join(",") + '\r\n';;

      this.vouchers.forEach(voucher => {
        csvContent += Object.values(voucher).join(",") + '\r\n';
      });

      this.publishFile(csvContent, 'vouchers.csv');
    }
  }

  private publishFile(csvContent: string, name: string) {
    let a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);

    //Set utf-8 header to let excel recognize its encoding
    let blob = new Blob(["\ufeff", csvContent], { type: 'text/csv' });
    a.href = window.URL.createObjectURL(blob);
    a.download = name;
    a.click();
  }

  public voucherSettings = {
    pager: {
      display: true,
      perPage: 10000000
    },
    columns: {
      code: {
        title: 'Voucher Code',
        width: '5%',
        isFilterable: false
      },
      amount: {
        title: 'Amount',
        width: '10%',
        valuePrepareFunction: (value: any, row: any) => {
          return value ? Intl.NumberFormat('en-GB', { style: 'currency', currency: row.row.data.currency, currencyDisplay: 'narrowSymbol' }).format(value) : null;
        },
        isFilterable: false
      },
      startDate: {
        title: 'Start Date',
        width: '10%',
        valuePrepareFunction: (value: any) => { return new DatePipe('en-GB').transform(value, 'dd/MM/yyyy'); },
        isFilterable: false
      },
      endDate: {
        title: 'End Date',
        width: '10%',
        valuePrepareFunction: (value: any) => { return new DatePipe('en-GB').transform(value, 'dd/MM/yyyy'); },
        isFilterable: false
      },
      category: {
        title: 'Category',
        width: '10%',
        isFilterable: true
      },
      createdBy: {
        title: 'Created By',
        width: '15%',
        isFilterable: false
      },
      voidedBy: {
        title: 'Voided By',
        width: '15%',
        isFilterable: false
      },
      isPromotional: {
        title: 'Promotional',
        width: '5%',
        isFilterable: false
      },
      reference: {
        title: 'Reference',
        width: '10%',
        isFilterable: false
      },
      status: {
        title: 'Status',
        width: '10%',
        isFilterable: false,
        valuePrepareFunction: (value: any) => {
          let voucherStatus = value;

          if (value == "Empty")
            return "Unused";

          if (value == "Booked")
            return "Redeemed";

          return voucherStatus;
        },
      }
    },
    attr: {
      class: 'table table-striped table-bordered'
    },
    actions: {
      delete: false,
      add: false,
      edit: false,
    }
  };

  onDateChange($event: any) {
    if ($event == undefined) {
      this.showErrorMsg('Select a valid date range');
      return;
    }

    if ($event[0] == undefined || $event[1] == undefined) {
      return;
    }

    let minDate = new Date($event[0].toJSON().split('T')[0]);
    let maxDate = new Date($event[1].toJSON().split('T')[0]);
    this.validateDateRange(minDate, maxDate);
  }

  validateDateRange(minDate: Date, maxDate: Date): boolean {
    let days = Math.floor((Date.UTC(maxDate.getFullYear(), maxDate.getMonth(), maxDate.getDate()) - Date.UTC(minDate.getFullYear(), minDate.getMonth(), minDate.getDate())) / (1000 * 60 * 60 * 24));
    if (days > 31) {
      this.showErrorMsg('Select a max of 31 days between dates');
      return false
    }
    return true;
  }

  private showErrorMsg(message: string = "Something went wrong!") {
    this.failureAlerts.push({
      type: 'danger',
      msg: message,
      timeout: 2000
    })
  }
}
